import { Injectable } from "@angular/core";
import { ChildModel } from "../_models/child-model";

@Injectable()
export class ParentService {
  constructor() {}

  shouldModalWithBrotherAttributionAfterChildSave(
    allExistingChildren: ChildModel[] = [],
    newChild: Partial<ChildModel>
  ): false | { lastName: string } {
    const BrotherWithSameSurname = allExistingChildren.find(
      (b) => b.lastName === newChild.lastName
    );
    if (!BrotherWithSameSurname || !newChild.lastName.trim()) {
      return false;
    }
    return { lastName: newChild.lastName.trim() };
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/parent.service.ts